
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"4.75","height":"21.965","viewBox":"0 0 4.75 21.965"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bac1cc","transform":"rotate(90 2.375 2.375)"}},[_c('circle',{attrs:{"data-name":"Ellipse 7207","cx":"2.375","cy":"2.375","r":"2.375"}}),_c('circle',{attrs:{"data-name":"Ellipse 7208","cx":"2.375","cy":"2.375","r":"2.375","transform":"translate(8.607)"}}),_c('circle',{attrs:{"data-name":"Ellipse 7209","cx":"2.375","cy":"2.375","r":"2.375","transform":"translate(17.215)"}})])])
          )
        }
      }
    